/** @format */

let appConfig = process.env.REACT_APP_CONFIG || {};

if (typeof JSON.parse(JSON.stringify(appConfig)) === 'string') {
  appConfig = JSON.parse(appConfig);
} else {
  appConfig = JSON.parse(JSON.stringify(appConfig));
}

const { ENVIRONMENT } = appConfig;

const sessionEndTime = new Date().getTime() + 1000 * 60 * 48; // 48 minutes

const config = {
  ENVIRONMENT,
  defaultPathName: '/',
  mobileScreenMaxWidth: 919,
  sessionEndTime: sessionEndTime,
  /** new broker users password minimum length */
  brokerNewPasswordMinimumLength: 8,
  friLansFinansLoginUrl: 'https://client.invoicerybusiness.se/login',
  vitecLoginUrl: 'https://express.maklare.vitec.net/',
  personalEmailUrl: 'https://webbmail.loopia.se',
  friaMaklareWebOriginUrl: process.env.REACT_APP_WEB_APP_URL,
  adminEmail: 'admin@friamaklare.se',
  googleMapsApiKey: process.env.REACT_APP_GOOGLEMAP_API_KEY,

  /**
   * Base url for Fria maklare APi server
   */
  baseApiUrl: process.env.REACT_APP_API_GATEWAY_URL
};

export default config;
